export enum PessoaAuditoriaAcessoComponente {
  METADADOS = <any> 'METADADOS',
  ENDERECOS = <any> 'ENDERECOS',
  DOCUMENTOS = <any> 'DOCUMENTOS',
  GENITORES = <any> 'GENITORES',
  OUTROS_NOMES = <any> 'OUTROS_NOMES',
  RELACIONAMENTOS = <any> 'RELACIONAMENTOS',
  ENDERECOS_ELETRONICOS = <any> 'ENDERECOS_ELETRONICOS',
  TELEFONES = <any> 'TELEFONES',
  GRAPHQL = <any> 'GRAPHQL',
}
